import { Button } from '@aws-amplify/ui-react';
import Modal from 'react-modal';

import loggedInImage from '../img/components/start/loggedin.png';

type LoggedInProps = {
  isOpen: boolean;
  hideLoggedIn: () => void;
};

const GetItemResult = (props: LoggedInProps) => {
  const { isOpen, hideLoggedIn } = props;
  return (
    <Modal
      isOpen={isOpen}
      style={{
        overlay: {
          position: 'absolute',
          top: 0,
          bottom: 0,
          width: '100%',
          inset: '0px',
          backgroundColor: '#fcefaa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        content: {
          inset: '0',
          width: '100%',
          backgroundColor: 'transparent',
          border: 'none',
          position: 'relative',
          textAlign: 'center',
        },
      }}
    >
      <img width="100%" src={loggedInImage} alt="ログインしました！" />
      <Button width={200} marginTop={20} variation="primary" onClick={hideLoggedIn}>
        閉じる
      </Button>
    </Modal>
  );
};
export default GetItemResult;
